import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import { deletePanel } from 'common/api/v1/panelsCompanies';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { addPanelsModalActions } from '../reducer';

import filterItems from './filterItems';

export default (filterData, id) => (dispatch) => {
    dispatch(addPanelsModalActions[BULK_UPDATE_ITEMS]());

    deletePanel(id)
        .then(() => {
            dispatch(addPanelsModalActions[BULK_UPDATE_ITEMS_SUCCESS]());
            if (!isEmpty(filterData)) dispatch(filterItems(filterData));
            showToast({ body: i18next.t('It was successfully added') });
        })
        .catch((error) => {
            dispatch(
                addPanelsModalActions[BULK_UPDATE_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
